import { Box, Center } from 'styled-system/jsx';
import Button from '@/common/components/base/button/Button.tsx';
import CheckIcon from '@/common/assets/icons/tickIcon.svg?react';
import { token } from 'styled-system/tokens';
import useModal from '@/common/hooks/useModal.ts';
import { SharedActionProps } from '@/modules/FileList/components/fileDetailCardActions/FileListlAction.type.ts';
import AcceptFileModalSelector from '@/modules/FileList/components/modals/acceptFileModals/AcceptFileModalSelector.tsx';
import RejectFileModal from '@/modules/FileList/components/modals/rejectFileModals/RejectFileModal.tsx';

export default ({ fileId }: SharedActionProps) => {
  const {
    open: isAcceptModalOpen,
    openModal: openAcceptModal,
    closeModal: closeAcceptModal,
  } = useModal();
  const {
    open: isRejectModalOpen,
    openModal: openRejectModal,
    closeModal: closeRejectModal,
  } = useModal();
  return (
    <>
      <Center borderTop="1px solid {colors.gray-2}">
        <Button
          onClick={openRejectModal}
          fullWidth
          variant="text"
          color="common"
        >
          رد پرونده
        </Button>
        <Box height="30px" width="2px" backgroundColor="gray-2" />
        <Button
          onClick={openAcceptModal}
          gap="5px"
          fullWidth
          variant="text"
          color="primary"
        >
          <CheckIcon stroke={token('colors.purple-2')} />
          قبول پرونده
        </Button>
      </Center>
      <AcceptFileModalSelector
        fileId={fileId}
        open={isAcceptModalOpen}
        closeModal={closeAcceptModal}
      />
      <RejectFileModal
        fileId={fileId}
        open={isRejectModalOpen}
        closeModal={closeRejectModal}
      />
    </>
  );
};
